import { CookiePreferences } from '../interfaces/cookie-preferences.interface';

export const COOKIE_CONSENT_COOKIE_NAME = 'cookieConsentPreferences';

export const DEFAULT_COOKIE_PREFERENCES: CookiePreferences = {
  necessary: true,
  performance: true,
  functional: true,
  targeting: false,
};
